export default "__VITE_ASSET__CtsQwxtr__"